import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import Button from '../Button';
import Icon from '../Icon';

export default class CreateButton extends React.Component {
  static propTypes = {
    createButton: PropTypes.string,
    createButtonType: PropTypes.string,
    createButtonIcon: PropTypes.string,
    createAction: PropTypes.func
  };

  render() {
    const { createButton, createButtonIcon, createButtonType, createAction } = this.props;

    if (!createButton) {
      return null;
    }

    if (createButtonType === 'link') {
      return (
        <Link to="/add">
          <Button style="primary">
            {createButtonIcon && <Icon iconType={createButtonIcon} />}
            {createButton}
          </Button>
        </Link>
      );
    } else {
      return (
        <Button style="primary" onClick={(e) => createAction(e)}>
          {createButtonIcon && <Icon iconType={createButtonIcon} />}
          {createButton}
        </Button>
      );
    }
  }
}
